import api from '@/api/api'
import Swal from 'sweetalert2'
import { getField, updateField } from 'vuex-map-fields'

export const BOOTSTRAP = 'BOOTSTRAP'
export const SET_STATE = 'SET_STATE'
export const SET_EDIT = 'SET_EDIT'
export const LOAD_FUNCIONARIOS = 'LOAD_FUNCIONARIOS'
export const DELETE_FUNCIONARIO = 'DELETE_FUNCIONARIO'
export const RESET_STATE = 'RESET_STATE'

const getDefaultState = () => {
  return {
    funcionarios: [],
    ready: false,
  }
}

const state = getDefaultState()

const getters = {
  getField,
}

const mutations = {
  updateField,
  [SET_STATE](state, payload) {
    Object.assign(state, payload)
  },
  [RESET_STATE](state) {
    Object.assign(state, getDefaultState())
  },
}

const actions = {
  async [LOAD_FUNCIONARIOS]({ commit, state }) {
    commit(SET_STATE, { ready: false })
    await api.listEntidade('funcionario').then(
      funcionarios => {
        commit(SET_STATE, { funcionarios, ready: true })
      },
    )
  },
  async [BOOTSTRAP]({ dispatch, commit, state }) {
    await dispatch(LOAD_FUNCIONARIOS)
  },
  async [DELETE_FUNCIONARIO]({ dispatch, commit, state }, funcionario) {
    const index = state.funcionarios.findIndex(c => c.id === funcionario.id)

    Swal.fire({
      title: 'Tem certeza que deseja excluir o Funcionário?',
      icon: 'question',
      showCancelButton: true,
      showLoaderOnConfirm: true,
      confirmButtonColor: '#109010',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Excluir',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
      focusConfirm: false,
      preConfirm: () => {
        return api.inativarEntidade('funcionario', funcionario.id).then(
          result => result,
          () => {
            Swal.fire({
              icon: 'error',
              title: 'Ocorreu algum erro!',
              text: 'Não foi possivel excluir o Funcionário!',
            })
          },
        )
      },
    }).then(result => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'O Funcionário foi excluído com sucesso!',
          icon: 'success',
          showConfirmButton: false,
          timer: 2500,
        })
        state.funcionarios.splice(index, 1)
        api.listEntidade('funcionario').then(result => {
          state.funcionarios = result
        })
      }
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
